export default {
  PARENT_PENDING: 'PARENT_PENDING',
  PARENT_COMPLETE: 'PARENT_COMPLETE',
  PARENT_ERROR: 'PARENT_ERROR',
  SET_PRINT_LANGUAGE: 'SET_PRINT_LANGUAGE',
}